<script>
  import { cssPrefix } from '../helper-classes.js'

  export let light
</script>

<figure class={`${cssPrefix}logo`} alt="gl-logo" class:is-light={light}>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 119.1 38.79">
    <path
      class={`${cssPrefix}logo-n`}
      d="M286.74,154.89l-6.3-6.3a14,14,0,1,1-19.15-19.73,8.75,8.75,0,0,1,14-10.2l1.91,1.91-1.83,1.83-1.91-1.91a6.17,6.17,0,0,0-9.48,7.81,5.89,5.89,0,0,0,.42.55l.34.36,23.86,23.86ZM262.8,131a11.51,11.51,0,0,0-1.84,1.49A11.41,11.41,0,0,0,264.59,151a11.51,11.51,0,0,0,8.87,0,11.35,11.35,0,0,0,3.63-2.44,11.5,11.5,0,0,0,1.49-1.84L262.88,131Z"
      transform="translate(-206.93 -116.1)"
    />
    <polygon
      class={`${cssPrefix}logo-l`}
      points="92.85 0.97 100.89 0.97 100.89 30.2 119.1 30.2 119.1 37.5 92.85 37.5 92.85 0.97"
    />
    <path
      class={`${cssPrefix}logo-g`}
      d="M206.93,135.4v-.1A18.18,18.18,0,0,1,225.5,117c6.38,0,10.22,1.72,13.92,4.86l-4.91,5.92c-2.73-2.28-5.16-3.59-9.26-3.59-5.67,0-10.17,5-10.17,11v.1c0,6.48,4.45,11.23,10.73,11.23a12.43,12.43,0,0,0,7.34-2.13v-5.06H225.3v-6.73h15.38V148a23,23,0,0,1-15.13,5.62c-11,0-18.62-7.74-18.62-18.22"
      transform="translate(-206.93 -116.1)"
    />
  </svg>
</figure>
